import React from "react"
import { Chip, Grid, Typography } from "@material-ui/core"

import SelectInput from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/SelectInput"

import { colors } from "@/styles/colors"

import useStyles from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/resources/Blocks/CustomFieldFillBlock/CustomFieldMultiSelect/styles"

export type CustomFieldOption = {
	id: number
	name: string
	displayName: string
	variable: string
	groupId: number
	groupDisplayName: string
}

type CustomFieldMultiSelectProps = {
	value: CustomFieldOption[]
	onChange: (options: CustomFieldOption[] | null) => void
	options: CustomFieldOption[]
}

const PLACEHOLDER = "Campo personalizado"
const NO_RESULTS_TEXT = "Nenhum campo encontrado para a busca."

const CustomFieldMultiSelect: React.FC<CustomFieldMultiSelectProps> = (props) => {
	const {
		value,
		onChange,
		options
	} = props

	const classes = useStyles()

	const handleGroupBy = (option: CustomFieldOption): string => {
		return option.groupDisplayName
	}

	const overrideGetOptionSelected = (option: CustomFieldOption, selectedValue: CustomFieldOption): boolean => {
		return option.id === selectedValue.id
	}

	const overrideGetOptionLabel = (option: CustomFieldOption): string => {
		return option.displayName
	}

	const overrideRenderOption = (option: CustomFieldOption): React.ReactNode => {
		return (
			<Grid
				container
				alignItems="center"
				className={classes.optionRow}
			>
				<Grid
					item
					className={classes.optionLabelWrapper}
				>
					<Typography className={classes.optionLabel}>
						{option.displayName}
					</Typography>
				</Grid>
			</Grid>
		)
	}

	const overrideRenderTag = (option: CustomFieldOption): React.ReactNode => {
		return (
			<Chip
				label={option.displayName}
				size="small"
				color="secondary"
				style={{ backgroundColor: colors.purple[500], color: colors.gray[50] }}
			/>
		)
	}

	return (
		<SelectInput
			multiple
			value={value}
			onChange={onChange}
			options={options}
			placeholder={PLACEHOLDER}
			getOptionSelected={overrideGetOptionSelected}
			getOptionLabel={overrideGetOptionLabel}
			groupBy={handleGroupBy}
			renderTag={overrideRenderTag}
			renderOption={overrideRenderOption}
			noOptionsText={NO_RESULTS_TEXT}
		/>
	)
}

export default CustomFieldMultiSelect
